import { styled } from '@mui/material/styles';

/**
 * Flexbox container that is full width and height and centers content.
 */
export const FillAndCenter = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  height: 100%;
`;
